import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import Page from "@atlaskit/page";
import { TriggerType } from "../../../../common/interfaces/flow/trigger/TriggerType";
import JiraWebhookTrigger from "../../../../connections/atlassian/jira/components/JiraWebhookTrigger";
import { selectFlow, setEditorSaved } from "../../../../redux/actions/integrationActions";
import CustomWebhookWidget from "./CustomWebhookWidget";
import ScheduledTrigger from "./ScheduledTrigger";
import JWTWebhookTrigger from "./JWTWebhookTrigger";
import LogEmitterTriggerPage from "./LogEmitterTriggerPage";

const TriggerPage = () => {
  const flow = useSelector((state) => state.integration.flow);
  const [triggerType, setTriggerType] = useState(TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE);
  const dispatch = useDispatch();

  const selectTriggerType = useCallback(
    (e) => {
      const newTriggerType = e.target.value;
      setTriggerType(newTriggerType);
      const updatedFlow = {
        ...flow,
        trigger: {
          ...flow.trigger,
          type: newTriggerType,
          value: undefined,
          config: flow.trigger.config || {},
        },
      };
      dispatch(selectFlow(updatedFlow));
      dispatch(setEditorSaved(false));
    },
    [dispatch, flow]
  );

  useEffect(() => {
    if (flow.trigger) {
      setTriggerType(flow.trigger.type);
    }
  }, [flow.trigger]);

  const triggerOptions = [
    { label: "Issue Event", value: TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE },
    { label: "Schedule Trigger", value: TriggerType.SCHEDULED_TRIGGER_TYPE },
    { label: "Incoming Webhook (Bearer)", value: TriggerType.CUSTOM_WEBHOOK_TRIGGER_TYPE },
    { label: "Incoming Webhook (JWT)", value: TriggerType.JWT_WEBHOOK_TRIGGER_TYPE },
    { label: "Log Emitter", value: TriggerType.LOG_TRIGGER_TYPE },
  ];

  return (
    <Page>
      <h4>Setup what triggers this integration</h4>
      {triggerOptions.map((option) => (
        <React.Fragment key={option.value}>
          <input name="trigger-type" type="radio" checked={triggerType === option.value} value={option.value} onChange={selectTriggerType} />
          &nbsp; {option.label} &nbsp;&nbsp;
        </React.Fragment>
      ))}
      <br />
      {triggerType === TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE && <JiraWebhookTrigger />}
      {triggerType === TriggerType.CUSTOM_WEBHOOK_TRIGGER_TYPE && <CustomWebhookWidget />}
      {triggerType === TriggerType.SCHEDULED_TRIGGER_TYPE && <ScheduledTrigger />}
      {triggerType === TriggerType.JWT_WEBHOOK_TRIGGER_TYPE && <JWTWebhookTrigger />}
      {triggerType === TriggerType.LOG_TRIGGER_TYPE && <LogEmitterTriggerPage />}
    </Page>
  );
};

export default TriggerPage;
